import React from 'react'

export const Foot = props => (
  <svg
    width={25}
    height={25}
    viewBox='0 0 40 40'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clip-path="url(#clip0_8179_69271)">
      <path d="M13.2661 12.0958C15.5943 10.3501 18.8528 9.57712 22.0135 10.2314C28.2845 11.5295 31.5553 16.549 31.6648 22.7976C31.7538 27.8753 28.5302 34.1297 23.6272 36.1522C20.6935 37.3623 16.8828 36.1253 15.689 33.0301C15.2435 31.8751 15.3311 30.7534 15.518 29.6246L15.6525 28.8707C15.7491 28.3482 15.8463 27.8225 15.9017 27.2893C16.014 26.2077 15.395 25.5345 14.6138 24.9764L14.2123 24.7056L13.2873 24.1208L12.8428 23.8167C11.792 23.0652 10.6808 21.9951 10.2197 20.0858C9.41227 16.7432 10.9018 13.8685 13.2661 12.0958ZM8.33333 5.83398C10.1743 5.83398 11.6667 7.32637 11.6667 9.16732C11.6667 11.0083 10.1743 12.5007 8.33333 12.5007C6.49238 12.5007 5 11.0083 5 9.16732C5 7.32637 6.49238 5.83398 8.33333 5.83398ZM30.8333 7.50065C31.7538 7.50065 32.5 8.24685 32.5 9.16732C32.5 10.0878 31.7538 10.834 30.8333 10.834C29.9128 10.834 29.1667 10.0878 29.1667 9.16732C29.1667 8.24685 29.9128 7.50065 30.8333 7.50065ZM15.8333 3.33398C17.214 3.33398 18.3333 4.45327 18.3333 5.83398C18.3333 7.2147 17.214 8.33398 15.8333 8.33398C14.4526 8.33398 13.3333 7.2147 13.3333 5.83398C13.3333 4.45327 14.4526 3.33398 15.8333 3.33398ZM24.1667 3.33398C25.5473 3.33398 26.6667 4.45327 26.6667 5.83398C26.6667 7.2147 25.5473 8.33398 24.1667 8.33398C22.786 8.33398 21.6667 7.2147 21.6667 5.83398C21.6667 4.45327 22.786 3.33398 24.1667 3.33398Z"/>
    </g>
    <defs>
      <clipPath id="clip0_8179_69271">
        <rect width="40" height="40" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)
